module.exports = __webpack_public_path__ + "static/media/favicon-32x32.f5312bc6.svg";